export default {
  SET_STATE: "creditz/SET_STATE",
  GET_RECEIVED_CREDITZ: "creditz/GET_RECEIVED_CREDITZ",
  CREATE_VIDEO_CREDITZ: "creditz/CREATE_VIDEO_CREDITZ",
  UPDATE_NOTIFICATION: "creditz/UPDATE_NOTIFICATION",
};
